import { SettingOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import "../../styles.scss";
import MegaTable from "../../../../components/MagaTableV2";
import { formatNumber } from '../../../../services/mixin';

const WarrantyInformation = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner_insurance?.list.map((col: any) => {
      if (col.field === 'original_amount') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheWarrantyInformation',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
    height: '400px',
  });

  useEffect(() => {
    if (stData.xesohuu_show) {
      stChange(stData.xesohuu_show.vehicle_insurance || [], 'vehicle_insurance');
    }
  }, [stData.xesohuu_show]);

  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <MegaTable
        stData={{ ...megaTableData, listData: stData.xesohuu_show_vehicle_insurance || [], loading: false }}
        stChange={(data) => {
          setMegaTableData((prev: any) => ({ ...prev, ...data }));
        }}
      />
    </>
  );
};
export default WarrantyInformation;
